module.exports = __webpack_public_path__ + "img/icon4-1.baa01508.svg";